<template>
  <FKBreadCrumb :page="$t('page.home')" />
  <div class="row">
    <div :class="indexPermission ? ['col-xxl-6', 'col-xxxl-6'] : ['col-12']">
      <UserSummary />
      <div class="row" v-if="!isAdmin && !isInternal">
        <div class="col-sm-6 mb-25" v-if="createPermission">
          <CreatePatientCard />
        </div>
        <div class="col-sm-6  mb-25" v-for="center in enabledCenters" :key="center.id">
          <ProfileCenterCard :center="center" />
        </div>
      </div>
      <PatientCancellationCarousel v-if="indexPermission" />
      <EventsCalendar v-if="(!isAdmin && !isInternal) && config.feature.messages" />
    </div>
    <div class="col-xxl-6 col-xxxl-6" v-if="indexPermission">
      <PatientsList :enableAddPatient="false" />
    </div>
    <div class="col-12" v-if="isAdmin">
      <QuickLook></QuickLook>
    </div>
    <div class="row" v-if="isInternal && assignment_strategy === 'by_hcp'">
      <div class="col-sm-6 mb-25">
        <InviteUserCard></InviteUserCard>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import FKBreadCrumb from "@/components/Widgets/BreadCrumb/FKBreadCrumb.vue";
import UserSummary from "@/components/FK/UserInfo/UserSummary.vue";
import PatientsList from "@/components/FK/Patient/PatientsList.vue";
import ProfileCenterCard from "@/components/FK/Profile/ProfileCenterCard.vue";
import CreatePatientCard from "@/components/FK/Welcome/CreatePatientCard.vue";
import QuickLook from "@/components/FK/Welcome/QuickLook.vue";
import stateStore from "@/utils/store";
import { CenterWithPermission, Role, UserInfo } from "@/utils/models/user.model";
import EventsCalendar from "@/components/FK/Events/EventsCalendar.vue";
import CONFIG from "@/utils/const/config";
import InviteUserCard from "@/components/FK/Welcome/InviteUserCard.vue";
import PatientCancellationCarousel from "@/components/FK/PatientDetail/PatientCancellationCarousel.vue";

export default defineComponent({
  name: "WelcomePage",
  components: {
    FKBreadCrumb,
    UserSummary,
    PatientsList,
    CreatePatientCard,
    ProfileCenterCard,
    EventsCalendar,
    QuickLook,
    InviteUserCard,
    PatientCancellationCarousel
  },
  computed: {
    config() { return CONFIG },
    isAdmin() { return stateStore.isAdmin() },
    isHCP() { return stateStore.user?.info.role.type === Role.hcp },
    isInternal() { return stateStore.user?.info.role.type === Role.internal },
    indexPermission(): boolean { return stateStore.getPermisison('index') || stateStore.user?.info.invitation_id !== null },
    createPermission(): boolean { return stateStore.getPermisison('store') },
    enabledCenters(): CenterWithPermission[] {
      return stateStore.centers().filter((center) => this.showCenter(center.id) && !center.is_custom_center);
    },
    assignment_strategy(): UserInfo['assignment_strategy'] { return stateStore.user?.info.assignment_strategy ?? 'by_center' }
  },
  methods: {
    showCenter(center_id: number): boolean {
      return stateStore.getCenterPermission(center_id, 'index') || stateStore.getCenterPermission(center_id, 'show') || stateStore.getCenterPermission(center_id, 'store') || stateStore.getCenterPermission(center_id, 'update') || stateStore.getCenterPermission(center_id, 'destroy');
    }
  },
});
</script>